import { render, staticRenderFns } from "./housingCun.vue?vue&type=template&id=56a218c6&scoped=true"
import script from "./housingCun.vue?vue&type=script&lang=js"
export * from "./housingCun.vue?vue&type=script&lang=js"
import style0 from "./housingCun.vue?vue&type=style&index=0&id=56a218c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a218c6",
  null
  
)

export default component.exports